(() => {
  const register = (name, initializer) => {
    if (window.SafeWalkV51Product?.register) window.SafeWalkV51Product.register(name, initializer);
    else (window.SafeWalkV51ProductQueue ||= []).push([name, initializer]);
  };

  register('size-tools', ({ root, parseJson, listen }) => {
    const sizeModal = root.querySelector('[data-size-guide-modal]');
    const calculatorModal = document.querySelector('[data-size-calculator-modal]');
    if (!sizeModal && !calculatorModal) return;
    const modalIsolation = new WeakMap();
    const modalFocusReturn = new WeakMap();
    const focusableSelector = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const setModalIsolation = (modal, active) => {
      if (!modal) return;
      if (active) {
        const previous = new Map();
        const isolationScope = root.contains(modal)
          ? root
          : modal.closest('main') || document.body;
        Array.from(isolationScope.children).forEach((sibling) => {
          if (sibling === modal || sibling.contains(modal)) return;
          previous.set(sibling, sibling.hasAttribute('inert'));
          sibling.setAttribute('inert', '');
        });
        modalIsolation.set(modal, { previous });
        return;
      }
      modalIsolation.get(modal)?.previous?.forEach((wasInert, sibling) => {
        if (!wasInert) sibling.removeAttribute('inert');
      });
      modalIsolation.delete(modal);
    };
    const openModal = (modal, trigger) => {
      if (!modal) return;
      modalFocusReturn.set(modal, trigger || document.activeElement);
      modal.hidden = false;
      setModalIsolation(modal, true);
      document.documentElement.classList.add('swv5-size-modal-open');
      requestAnimationFrame(() => modal.querySelector(focusableSelector)?.focus());
    };
    const closeModal = (modal) => {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      setModalIsolation(modal, false);
      if (![sizeModal, calculatorModal].some((candidate) => candidate && !candidate.hidden)) {
        document.documentElement.classList.remove('swv5-size-modal-open');
      }
      const returnTarget = modalFocusReturn.get(modal);
      modalFocusReturn.delete(modal);
      returnTarget?.focus?.();
    };
    const trapFocus = (event, modal) => {
      if (event.key !== 'Tab' || !modal || modal.hidden) return;
      const focusable = Array.from(modal.querySelectorAll(focusableSelector)).filter((node) => !node.hidden && node.offsetParent !== null);
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      const first = focusable[0];
      const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    const openSizeGuide = (event) => {
      if (!sizeModal || sizeModal.dataset.sizeGuideEnabled === 'false') return;
      openModal(sizeModal, event?.currentTarget);
    };
    const openCalculator = (event) => {
      if (!calculatorModal || calculatorModal.dataset.sizeCalculatorEnabled === 'false') return;
      openModal(calculatorModal, event?.currentTarget);
    };
    const sizeGuideEnabled = Boolean(sizeModal && sizeModal.dataset.sizeGuideEnabled !== 'false');
    const calculatorEnabled = Boolean(calculatorModal && calculatorModal.dataset.sizeCalculatorEnabled !== 'false');
    root.querySelectorAll('[data-size-guide-trigger]').forEach((button) => {
      button.hidden = !sizeGuideEnabled;
      button.disabled = !sizeGuideEnabled;
      button.setAttribute('aria-hidden', String(!sizeGuideEnabled));
      if (sizeGuideEnabled) listen(button, 'click', openSizeGuide);
    });
    root.querySelectorAll('[data-size-guide-close]').forEach((button) => listen(button, 'click', () => closeModal(sizeModal)));
    root.querySelectorAll('[data-size-calculator-trigger]').forEach((button) => {
      button.hidden = !calculatorEnabled;
      button.disabled = !calculatorEnabled;
      button.setAttribute('aria-hidden', String(!calculatorEnabled));
      if (calculatorEnabled) listen(button, 'click', openCalculator);
    });
    calculatorModal?.querySelectorAll('[data-size-calculator-close]').forEach((button) => listen(button, 'click', () => closeModal(calculatorModal)));
    listen(sizeModal, 'click', (event) => {
      if (event.target === sizeModal) closeModal(sizeModal);
    });
    listen(calculatorModal, 'click', (event) => {
      if (event.target === calculatorModal) closeModal(calculatorModal);
    });
    listen(document, 'keydown', (event) => {
      const activeModal = [calculatorModal, sizeModal].find((modal) => modal && !modal.hidden);
      if (!activeModal) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal(activeModal);
        return;
      }
      trapFocus(event, activeModal);
    });
    listen(document, 'shopify:block:select', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (sizeModal && (target === sizeModal || sizeModal.contains(target))) openModal(sizeModal, target);
      if (calculatorModal && (target === calculatorModal || calculatorModal.contains(target))) openModal(calculatorModal, target);
    });
    const loadSizes = () => {
      const sharedRules = Array.from(root.querySelectorAll('[data-size-guide-row]'));
      const fallbackRules = Array.from(calculatorModal?.querySelectorAll('[data-size-calculator-size-rule]') || []);
      return (sharedRules.length ? sharedRules : fallbackRules)
        .map((rule) => ({
          key: String(rule.dataset.sizeKey || ''),
          min: Number(rule.dataset.sizeMin),
          max: Number(rule.dataset.sizeMax),
          range: String(rule.dataset.sizeRange || '')
        }))
        .filter((size) => size.key && Number.isFinite(size.min) && Number.isFinite(size.max) && size.max >= size.min)
        .sort((left, right) => left.min - right.min || left.max - right.max);
    };
    const sizesByKey = new Map(loadSizes().map((size) => [size.key, size]));
    const bidi = (value, direction) => Object.assign(document.createElement('bdi'), { dir: direction, textContent: String(value) });
    root.querySelectorAll('[data-variant-picker]').forEach((picker) => {
      const enabled = picker.dataset.sizeHintsEnabled !== 'false';
      picker.querySelectorAll('[data-size-pill-key]').forEach((pill) => {
        const hint = pill.querySelector('[data-size-pill-hint]');
        const key = pill.dataset.sizePillKey || '';
        if (!hint || !enabled) return;
        const size = sizesByKey.get(key);
        hint.replaceChildren(
          bidi(picker.dataset.sizeHintPrefix || '', 'rtl'),
          bidi(`${size?.min ?? ''}–${size?.max ?? ''}`, 'ltr'),
          bidi(` ${picker.dataset.sizeHintUnit || ''}`, 'rtl')
        );
        hint.hidden = !size;
      });
    });
    if (!calculatorModal) {
      return () => closeModal(sizeModal);
    }

    const parseCalculatorJson = (selector, fallback = {}) => {
      const node = calculatorModal.querySelector(selector);
      if (!node) return fallback;
      try {
        const parsed = JSON.parse(node.textContent || '');
        return parsed && typeof parsed === 'object' ? parsed : fallback;
      } catch (error) {
        return fallback;
      }
    };
    const legacyCalculatorConfig = parseCalculatorJson(
      '[data-size-calculator-config]',
      parseCalculatorJson('[data-size-calculator-copy]', {})
    );
    const weightCalculatorConfig = parseCalculatorJson('[data-size-calculator-weight-config]', {});
    const labelCalculatorConfig = parseCalculatorJson('[data-size-calculator-label-config]', {});
    const calculatorConfig = {
      ...legacyCalculatorConfig,
      ...weightCalculatorConfig,
      labels: {
        ...(legacyCalculatorConfig.labels || legacyCalculatorConfig.copy || {}),
        ...(labelCalculatorConfig.labels || labelCalculatorConfig.copy || labelCalculatorConfig)
      }
    };
    const labels = calculatorConfig.labels && typeof calculatorConfig.labels === 'object'
      ? calculatorConfig.labels
      : calculatorConfig.copy && typeof calculatorConfig.copy === 'object'
        ? calculatorConfig.copy
        : calculatorConfig;
    const text = (key) => {
      const value = labels[key];
      return typeof value === 'string' ? value : '';
    };
    const interpolate = (template, values) => {
      return String(template).replace(/\{\{?\s*([a-zA-Z_]+)\s*\}?\}|\[([a-zA-Z_]+)\]/g, (match, braceKey, bracketKey) => {
        const key = braceKey || bracketKey;
        return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
      });
    };
    const escapeHtml = (value) => {
      const node = document.createElement('div');
      node.textContent = String(value ?? '');
      return node.innerHTML;
    };
    const weightInput = calculatorModal.querySelector('[data-size-calculator-weight]');
    const breedSelect = calculatorModal.querySelector('[data-size-calculator-breed]');
    const result = calculatorModal.querySelector('[data-size-calculator-result]');
    const methodButtons = Array.from(calculatorModal.querySelectorAll('[data-size-method]'));
    const panels = Array.from(calculatorModal.querySelectorAll('[data-size-panel]'));
    const weightUnit = calculatorConfig.weight?.unit || '';
    const breedProfiles = {};
    Array.from(breedSelect?.options || []).forEach((option) => {
      const min = Number(option.dataset.breedMin || option.dataset.min);
      const max = Number(option.dataset.breedMax || option.dataset.max);
      if (!option.value || option.dataset.breedProfile === 'mixed' || !Number.isFinite(min) || !Number.isFinite(max)) return;
      const supportedMin = Math.max(min, Number(weightInput?.min || calculatorConfig.weight?.min));
      const supportedMax = Math.min(max, Number(weightInput?.max || calculatorConfig.weight?.max));
      if (supportedMax < supportedMin) return;
      breedProfiles[option.value] = {
        label: option.dataset.breedLabel || option.dataset.label || option.textContent?.trim() || '',
        min: supportedMin,
        max: supportedMax
      };
    });
    const matchingSizes = (weight, sizes) => sizes.filter((size) => weight >= size.min && weight <= size.max);
    const recommendSize = (weight, sizes) => {
      const matches = matchingSizes(weight, sizes);
      if (matches.length) return matches.at(-1)?.key || '';
      return sizes.find((size) => weight < size.min)?.key || sizes.at(-1)?.key || '';
    };
    const sizeRange = (size, sizes) => sizes.find((candidate) => candidate.key === size)?.range || '';
    const formatWeight = (weight) => Number.isInteger(weight) ? String(weight) : String(weight);
    const showError = (heading, body) => {
      if (!result) return;
      result.hidden = false;
      result.innerHTML = '<strong>' + escapeHtml(heading) + '</strong><span>' + escapeHtml(body) + '</span>';
    };
    const switchMethod = (method) => {
      methodButtons.forEach((button) => {
        const active = button.dataset.sizeMethod === method;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.sizePanel !== method; });
      if (result) result.hidden = true;
    };
    const renderWeight = () => {
      if (!result) return;
      const sizes = loadSizes();
      if (!sizes.length) {
        showError(
          text('missingSizeRulesHeading'),
          text('missingSizeRulesText')
        );
        return;
      }
      const weight = Number(weightInput?.value || 0);
      const minWeight = Number(weightInput?.min || calculatorConfig.weight?.min);
      const maxWeight = Number(weightInput?.max || calculatorConfig.weight?.max);
      if (!weight || weight < minWeight || weight > maxWeight) {
        showError(
          interpolate(text('weightErrorHeading'), {
            min: formatWeight(minWeight),
            max: formatWeight(maxWeight),
            unit: weightUnit
          }),
          text('weightErrorText')
        );
        weightInput?.focus();
        return;
      }
      const matches = matchingSizes(weight, sizes);
      const size = recommendSize(weight, sizes);
      const hasOverlap = matches.length > 1;
      const templateValues = {
        weight: formatWeight(weight),
        unit: weightUnit,
        size
      };
      const buildNote = hasOverlap
        ? interpolate(text('boundaryNoteTemplate'), templateValues)
        : text('largestBuildNote');
      result.hidden = false;
      result.innerHTML = '<span class="swv5-size-calculator__result-label">' + escapeHtml(text('weightResultLabel')) + '</span><strong>' + escapeHtml(interpolate(text('sizeHeadingTemplate'), { size })) + '</strong><span class="swv5-size-calculator__result-range swv5-size-calculator__result-range--numeric">' + escapeHtml(sizeRange(size, sizes)) + '</span><span class="swv5-size-calculator__build-note">' + escapeHtml(buildNote) + '</span><div class="swv5-size-calculator__result-actions"><button type="button" data-size-apply="' + escapeHtml(size) + '">' + escapeHtml(interpolate(text('chooseSizeTemplate'), { size })) + '</button></div>';
    };
    const renderBreed = () => {
      if (!result) return;
      const sizes = loadSizes();
      if (!sizes.length) {
        showError(
          text('missingSizeRulesHeading'),
          text('missingSizeRulesText')
        );
        return;
      }
      const breedKey = breedSelect?.value || '';
      const selectedOption = breedSelect?.selectedOptions?.[0];
      const hasBreedProfiles = Object.keys(breedProfiles).length > 0;
      if (!hasBreedProfiles && breedKey !== 'mixed') {
        showError(
          text('missingBreedProfilesHeading'),
          text('missingBreedProfilesText')
        );
        return;
      }
      if (!breedKey) {
        showError(
          text('breedErrorHeading'),
          text('breedErrorText')
        );
        breedSelect?.focus();
        return;
      }
      if (breedKey === 'mixed' || selectedOption?.dataset.breedProfile === 'mixed') {
        result.hidden = false;
        result.innerHTML = '<span class="swv5-size-calculator__result-label">' + escapeHtml(text('mixedResultLabel')) + '</span><strong>' + escapeHtml(text('mixedResultHeading')) + '</strong><span>' + escapeHtml(text('mixedResultText')) + '</span><button type="button" data-switch-to-weight>' + escapeHtml(text('switchToWeight')) + '</button>';
        return;
      }
      const profile = breedProfiles[breedKey];
      if (!profile) {
        showError(
          text('missingBreedProfileHeading'),
          text('missingBreedProfileText')
        );
        return;
      }
      const sizeOrder = sizes.map((size) => size.key);
      const firstSize = recommendSize(profile.min, sizes);
      const lastSize = recommendSize(profile.max, sizes);
      const firstIndex = sizeOrder.indexOf(firstSize);
      const lastIndex = sizeOrder.indexOf(lastSize);
      const possibleSizes = firstIndex >= 0 && lastIndex >= firstIndex ? sizeOrder.slice(firstIndex, lastIndex + 1) : [];
      const range = formatWeight(profile.min) + '-' + formatWeight(profile.max) + ' ' + weightUnit;
      const breedRange = interpolate(text('breedRangeTemplate'), {
        breed: profile.label,
        range
      });
      result.hidden = false;
      if (possibleSizes.length === 1) {
        result.innerHTML = '<span class="swv5-size-calculator__result-label">' + escapeHtml(text('breedResultLabel')) + '</span><strong>' + escapeHtml(interpolate(text('sizeHeadingTemplate'), { size: firstSize })) + '</strong><span class="swv5-size-calculator__result-range">' + escapeHtml(breedRange) + '</span><span class="swv5-size-calculator__build-note">' + escapeHtml(text('breedPriorityNote')) + '</span><button type="button" data-size-apply="' + escapeHtml(firstSize) + '">' + escapeHtml(interpolate(text('chooseSizeTemplate'), { size: firstSize })) + '</button>';
        return;
      }
      const sizeSeparator = text('sizeSeparator').trim();
      const sizeChoices = possibleSizes.map((size) => `\u2066${size}\u2069`).join(`\u00a0${sizeSeparator}\u00a0`);
      result.innerHTML = '<span class="swv5-size-calculator__result-label">' + escapeHtml(text('weightDecidesLabel')) + '</span><strong data-size-choice-heading>' + escapeHtml(sizeChoices) + '</strong><span class="swv5-size-calculator__result-range">' + escapeHtml(breedRange) + '</span><span class="swv5-size-calculator__build-note">' + escapeHtml(text('breedCrossesSizesNote')) + '</span><button type="button" data-switch-to-weight>' + escapeHtml(text('switchToWeight')) + '</button>';
    };
    methodButtons.forEach((button) => {
      listen(button, 'click', () => switchMethod(button.dataset.sizeMethod));
    });
    methodButtons.forEach((button, index) => {
      listen(button, 'keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const direction = event.key === 'ArrowLeft' ? -1 : 1;
        const nextIndex = event.key === 'Home'
          ? 0
          : event.key === 'End'
            ? methodButtons.length - 1
            : (index + direction + methodButtons.length) % methodButtons.length;
        const nextButton = methodButtons[nextIndex];
        if (!nextButton) return;
        switchMethod(nextButton.dataset.sizeMethod);
        nextButton.focus();
      });
    });
    calculatorModal.querySelectorAll('[data-size-calculator-submit]').forEach((button) => {
      listen(button, 'click', () => {
        if (button.dataset.sizeSubmitMethod === 'breed') renderBreed();
        else renderWeight();
      });
    });
    listen(weightInput, 'keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      renderWeight();
    });
    listen(result, 'click', (event) => {
      if (root.swv5Purchase?.isBusy()) return;
      if (event.target.closest('[data-switch-to-weight]')) {
        switchMethod('weight');
        weightInput?.focus();
        return;
      }
      const applyButton = event.target.closest('[data-size-apply]');
      if (!applyButton) return;
      const requestedSize = applyButton.dataset.sizeApply;
      const sizeInput = Array.from(root.querySelectorAll('.swv5-option--size [data-option-value]')).find((input) => {
        return (root.swv5Purchase?.normalizeSize(input.value) || String(input.value).toUpperCase()) === requestedSize;
      });
      if (!sizeInput) return;
      sizeInput.checked = true;
      sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
      closeModal(calculatorModal);
    });

    return () => {
      closeModal(sizeModal);
      closeModal(calculatorModal);
    };
  });
})();
